// The sole reason (for now) for this component to exist is to remove the perpetual "the component configuration does not exist" error from /global-content/configuration path.
// There "might" be other uses for it in the future.

const Configuration = () => {
  return null;
};

export default Configuration;
